import actionTypes from 'SRC/modules/redux/actionTypes'

export const setQuery = query => ({
  type: actionTypes.SET_USERS_LIST_QUERY,
  payload: query
})
